




export default class SdkDefine{

    
    public static FACE_BOOK_NAME : string = "facebook";
    public static LINE_NAME : string = "line";
    
    // "token":"",如果是token登陆就传这个值
    // "thirdUnionId":"",--第三方平台unonId,如果是游客,则代表设备id ,如果是token登陆就代表token
    // "passportThridType":1, 登陆类型 0游客  2facebook  3line 4token
    // "headImg":"", --头像
    // "nickname":"", 昵称
    // "gender": 性别 1男  2女
        
}
